<template>
  <div class="bar-chart" :style="{ width, height }">
    <div
      v-for="i in sum"
      :key="i"
      class="bar"
      :class="{ 'active-bar': num >= i }"
      :style="{ height: getHeight(i) }"
    />
  </div>
</template>

<script>
export default {
  props: {
    /** 宽度 */
    width: {
      type: String,
      default: '80px',
    },
    /** 高度 */
    height: {
      type: String,
      default: '40px',
    },
    /** 激活数 */
    num: {
      type: Number,
      required: true,
    },
    /** 总数 */
    sum: {
      type: Number,
      default: 5,
    },
  },
  methods: {
    /**
     * 获取高度间隔
     * @param {number} num 高度占比数
     */
    getHeight(num) {
      return `${(100 / this.sum).toFixed(2) * num}%`;
    },
  },
};
</script>

<style scoped lang="scss">
.bar-chart {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .bar {
    flex: 1;
    margin: 0 1px;
    background-color: #C0C4CC;
  }
  .active-bar {
    background-color: #409EFF;
  }
}
</style>
